/* Settings & safety (group Account): privacy center, safety and security, personalization (language,
   accessibility, notifications), offline and sync, and devices. Importing this file also runs boot.ts,
   which applies the saved accessibility and language preferences app-wide and installs the offline
   cache for chat history reads. */
import { lazy } from 'react';
import { Settings } from 'lucide-react';
import { defineFeature } from '../../app/feature';
import './boot';

export default defineFeature({
  id: 'settings',
  title: 'Settings & safety',
  short: 'Settings',
  icon: Settings,
  group: 'Account',
  route: '/settings',
  order: 90,
  screen: lazy(() => import('./Screen.tsx')),
  commands: [
    { id: 'privacy', title: 'Privacy center', to: '/settings/privacy', keywords: ['privacy', 'retention', 'training', 'memory'] },
    { id: 'export', title: 'Export all my data', to: '/settings/privacy?do=export', keywords: ['download', 'export', 'takeout'] },
    { id: 'security', title: 'Account security: sessions, passkeys, 2FA, API keys', to: '/settings/safety#security', keywords: ['password', 'passkey', '2fa', 'totp', 'api key', 'sessions'] },
    { id: 'signout-all', title: 'Sign out everywhere', to: '/settings/account?do=signout-all', keywords: ['sessions', 'logout'] },
    { id: 'reports', title: 'My reports', to: '/settings/safety#reports', keywords: ['report', 'appeal', 'moderation'] },
    { id: 'a11y', title: 'Accessibility and language', to: '/settings/personal', keywords: ['contrast', 'motion', 'text size', 'captions', 'language', 'idioma'] },
    { id: 'notifications', title: 'Notification settings', to: '/settings/personal#notifications', keywords: ['quiet hours', 'push', 'email'] },
    { id: 'offline', title: 'Offline & sync', to: '/settings/offline', keywords: ['cache', 'offline'] },
    { id: 'devices', title: 'Devices', to: '/settings/devices', keywords: ['android', 'windows', 'extension', 'shortcut'] },
  ],
  capabilities: [
    'MEM-06', 'SAFE-01', 'SAFE-02', 'SAFE-03', 'SAFE-04', 'SAFE-05', 'SAFE-06', 'SAFE-07', 'SAFE-08', 'SAFE-09',
    'PLAT-01', 'PLAT-02', 'PLAT-03', 'PLAT-04', 'PLAT-06', 'PLAT-07', 'MODEL-01',
    'DEV-01', 'DEV-02', 'DEV-03', 'DEV-04', 'DEV-05', 'DEV-06', 'DEV-07',
  ],
});
